import styles from "./ArticleHeader.module.scss";

const ArticleHeader = ({ children }: { children: React.ReactNode }) => {
  return <header className={styles.root}>{children}</header>;
};

export default ArticleHeader;
